import {Edit} from "../pages/edit/Edit";
import {List} from "../pages/list/List";
import {allRoles} from "../../../../_emywork/UIMenu";
import {roles} from "../../../../index";

export const CONTEXT = "skills";
export const IDENTIFIER = "id";


/* Routing helpers */
export const ROUTE_PREFIX = "/"+CONTEXT;
export const ROUTES = {
  new : { path: `${ROUTE_PREFIX}/new`, component: Edit, accepts:[{...roles}.super_admin] },
  edit : { path: `${ROUTE_PREFIX}/:${IDENTIFIER}/edit`, component: Edit, accepts:[{...roles}.super_admin] },
  list : { path: `${ROUTE_PREFIX}/list`, component: List, accepts: [{...roles}.super_admin] },
}

export const ROUTE_DEFAULT = ROUTES.list.path;
export const CONTEXT_TITLE = {
  singular: "SKILL",
  plural: "SKILLS",
}







